export default __webpack_public_path__ + "static/amemoria-bbde7e73b17b923c2200f0d4e70b40c3.webp";